import { useCallback } from "react";
import { useAuthenticatedRequestService } from "./service.base";
import {
  IpWhitelistEntry,
  AddIpWhitelistRequest,
  AddIpWhitelistResponse,
  UpdateIpWhitelistRequest,
} from "../types/ip-whitelist.types";

export function useIpWhitelistService() {
  const IP_WHITELIST_PATH = "ip-whitelist";
  const { authGet, authPost, authPut, authDelete } = useAuthenticatedRequestService();

  const getAll = useCallback(
    async function (): Promise<IpWhitelistEntry[]> {
      return await authGet(IP_WHITELIST_PATH);
    },
    [authGet]
  );

  const getById = useCallback(
    async function (id: number): Promise<IpWhitelistEntry> {
      return await authGet(`${IP_WHITELIST_PATH}/${id}`);
    },
    [authGet]
  );

  const add = useCallback(
    async function (request: AddIpWhitelistRequest): Promise<AddIpWhitelistResponse> {
      return await authPost(IP_WHITELIST_PATH, request);
    },
    [authPost]
  );

  const update = useCallback(
    async function (id: number, request: UpdateIpWhitelistRequest): Promise<IpWhitelistEntry> {
      return await authPut(`${IP_WHITELIST_PATH}/${id}`, request);
    },
    [authPut]
  );

  const remove = useCallback(
    async function (id: number): Promise<{ message: string }> {
      return await authDelete(`${IP_WHITELIST_PATH}/${id}`);
    },
    [authDelete]
  );

  const getClientIp = useCallback(
    async function (): Promise<{ ipAddress: string | null }> {
      return await authGet(`${IP_WHITELIST_PATH}/client-ip`);
    },
    [authGet]
  );

  return {
    getAll,
    getById,
    add,
    update,
    remove,
    getClientIp,
  };
}
